module.exports = __webpack_public_path__ + "static/media/blog-recent-4.543df6b2.jpg";